import axios from 'axios'
import { API_URL } from 'services/config'
import WithholdingListItem from 'models/WithholdingListItem'
import Paginator from 'models/Paginator'
// import withholdingsListMock from 'mocks/Withholdings/list.json'

class WithholdingService {
    listWithholdings = (params) =>
        axios
            .get(`${API_URL}/withholdings`, { params })
            .then(({ data: { data, pagination } }) => ({
                withholdings: data.map((withholding) => WithholdingListItem.fromJson(withholding)),
                paginator: Paginator.fromJson(pagination),
            }))

    // listWithholdings = () => {
    //     const { data, pagination } = withholdingsListMock
    //
    //     return Promise.resolve({
    //         withholdings: data.map((withholding) => WithholdingListItem.fromJson(withholding)),
    //         paginator: Paginator.fromJson(pagination),
    //     })
    // }
}

export default WithholdingService
